let gridSwiper = null;
let cardSwiper = null;

export function mountSwiper() {
    const displayCardSlider = document.querySelectorAll('div[data-swiper="display-card"]');
    const displayGridSlider = document.querySelectorAll('div[data-swiper="display-grid"]');

    if (displayGridSlider.length) {
        displayGridSlider.forEach(panel => {
            const swiperElement = panel.querySelector('.swiper');
            if (swiperElement) {
                const autoPlay = swiperElement.dataset.autoPlay !== undefined ?
                    swiperElement.dataset.autoPlay.toLowerCase() === 'true' :
                    true;

                gridSwiper = new Swiper(swiperElement, {
                    effect: 'fade',
                    speed: 350,
                    loop: true,
                    resistanceRatio: 0,
                    autoplay: autoPlay ? { delay: 10000, disableOnInteraction: false } : false,
                    allowTouchMove: true,
                    navigation: {
                        nextEl: 'button[data-swiper-grid-go="next"]',
                        prevEl: 'button[data-swiper-grid-go="prev"]'
                    },
                    on: {
                        slideChange: function() {
                            const activeIndex = this.realIndex + 1;
                            const totalSlides = this.slides ? this.slides.length : 1;
                            const showWhenEmpty = document.querySelector('#gridBtns .show-when-empty');
                            const hideWhenEmpty = document.querySelector('#gridBtns .hide-when-empty');

                            if (totalSlides <= 0) {
                                showWhenEmpty?.classList.remove("hidden");
                                hideWhenEmpty?.classList.add("hidden");
                            } else {
                                const activeSlideElement = document.querySelector('#gridBtns span[data-active-slide]');
                                if (activeSlideElement) {
                                    activeSlideElement.innerHTML = activeIndex;
                                }
                                const totalSlidesElement = document.querySelector('#gridBtns span[data-total-slides]');
                                if (totalSlidesElement) {
                                    totalSlidesElement.innerHTML = totalSlides;
                                }
                                showWhenEmpty?.classList.add("hidden");
                                hideWhenEmpty?.classList.remove("hidden");
                            }
                        }
                    }

                });
            }
        });
    }

    if (displayCardSlider.length) {
        displayCardSlider.forEach(panel => {
            const swiperElement = panel.querySelector('.swiper');
            if (swiperElement) {
                const autoPlay = swiperElement.dataset.autoPlay !== undefined ?
                    swiperElement.dataset.autoPlay.toLowerCase() === 'true' :
                    true;

                const swiperWrapper = swiperElement.querySelector('.swiper-wrapper');
                let manualClones = 0;
                let uniqueManualClones = 0;

                if (swiperWrapper) {
                    if (swiperWrapper.dataset.manualClones) {
                        manualClones = parseInt(swiperWrapper.dataset.manualClones, 10);

                        if (isNaN(manualClones)) {
                            manualClones = 0;
                        }
                    }
                    if (swiperWrapper.dataset.uniqueManualClones) {
                        uniqueManualClones = parseInt(swiperWrapper.dataset.uniqueManualClones, 10);

                        if (isNaN(uniqueManualClones)) {
                            uniqueManualClones = 0;
                        }
                    }
                }

                cardSwiper = new Swiper(swiperElement, {
                    effect: 'coverflow',
                    slidesPerView: 3,
                    spaceBetween: 40,
                    centeredSlides: true,
                    loop: true,
                    autoplay: autoPlay ? { delay: 10000, disableOnInteraction: false } : false,
                    navigation: {
                        nextEl: 'button[data-swiper-card-go="next"]',
                        prevEl: 'button[data-swiper-card-go="prev"]'
                    },
                    coverflowEffect: {
                        depth: 40,
                        modifier: 1,
                        rotate: 0,
                        scale: 0.95,
                        slideShadows: false,
                    },
                    on: {
                        slideChange: function() {

                            let activeIndex = this.realIndex + 1;

                            if (uniqueManualClones > 0) {
                                activeIndex = (this.realIndex % uniqueManualClones) + 1;
                            }

                            const totalSlides = this.slides ? (this.slides.length - manualClones) : 1;
                            const showWhenEmpty = document.querySelector('#sliderBtns .show-when-empty');
                            const hideWhenEmpty = document.querySelector('#sliderBtns .hide-when-empty');

                            if (totalSlides <= 0) {
                                showWhenEmpty?.classList.remove("hidden");
                                hideWhenEmpty?.classList.add("hidden");
                            } else {
                                const activeSlideElement = document.querySelector('#sliderBtns span[data-active-slide]');
                                if (activeSlideElement) {
                                    activeSlideElement.innerHTML = activeIndex;
                                }
                                const totalSlidesElement = document.querySelector('#sliderBtns span[data-total-slides]');
                                if (totalSlidesElement) {
                                    totalSlidesElement.innerHTML = totalSlides;
                                }
                                showWhenEmpty?.classList.add("hidden");
                                hideWhenEmpty?.classList.remove("hidden");
                            }
                        }
                    }
                });
            }
        });
    }
}

window.addEventListener('load', () => {
    mountSwiper();
});

export const initializeSwiper = () => {
    if (gridSwiper) {
        gridSwiper.destroy(true, true);
    }
    if (cardSwiper) {
        cardSwiper.destroy(true, true);
    }
    mountSwiper();
};
